export default __webpack_public_path__ + "static/media/7b.b9f52eea.png";